module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/bootstrap/glyphicons-halflings-regular.woff2
// module id = 862
// module chunks = 0